import './QuotePurchaseTrackingCardSkeleton.scss';

/** Skeleton de carga para la card de seguimiento de compra */
const QuotePurchaseTrackingCardSkeleton = () => {
  const deviceRows = [1, 2];

  return (
    <div className="quotePurchaseTrackingCardSkeleton">
      <div className="cardHeader">
        <div className="headerLeft">
          <div className="iconSkeleton animationLoader" />
          <div className="orderInfo">
            <div className="labelSkeleton animationLoader" />
            <div className="datesSkeleton animationLoader" />
          </div>
        </div>
        <div className="headerRight">
          <div className="colSkeleton">
            <div className="colLabelSkeleton animationLoader" />
            <div className="colValueSkeleton animationLoader" />
          </div>
          <div className="statusSkeleton animationLoader" />
        </div>
      </div>
      <div className="deviceList">
        {deviceRows.map(i => (
          <div key={i} className="deviceRow">
            <div className="deviceInfo">
              <div className="deviceNameSkeleton animationLoader" />
              <div className="deviceSkuSkeleton animationLoader" />
            </div>
            <div className="deviceCols">
              <div className="colSkeleton">
                <div className="colLabelSkeleton animationLoader" />
                <div className="colValueSkeleton animationLoader" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuotePurchaseTrackingCardSkeleton;
